import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import { IBriefInflunecerPendingReviewFacets } from "@shared/lib/types/brief";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY } from "../constants";
import { BriefService } from "../services/brief.service";

export function useGetBriefInfluencerPendingReviewFacets({
  briefId,
  status,
  statuses,
  isShortListed,
}: {
  briefId: string;
  status?: string;
  statuses?: string[];
  isShortListed?: boolean;
}) {
  const { data, isError, isLoading, error } = useQuery<
    BackednResponse<IBriefInflunecerPendingReviewFacets>
  >({
    queryKey: [
      ...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY,
      "facets",
      briefId,
      status,
      "pending-review",
      statuses,
      isShortListed,
    ],
    queryFn: () =>
      BriefService.getBriefInfluencerPendingReviewFacets({
        briefId,
        status,
        statuses,
        isShortListed,
      }),
    enabled: !!briefId,
  });

  const errorMessage = isError && error?.message;
  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    pendingReviewFacets: data?.data,
    isFetching: isLoading,
  };
}
